import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => {
    return {
        title: {
            '&.MuiTypography-root': {
                fontSize: '36px',
                fontWeight: 700,
            },
        },
        blue: {
            color: theme.palette.primary.main,
        },
        pageContainer: {
            marginTop: theme.spacing(1),
            paddingRight: '9.72%',
            paddingLeft: '9.72%',
        },
        paper: {
            padding: '11px 20px',
        },
        section: {
            margin: '11px 0 40px',
        },
        sectionTitle: {
            '&.MuiTypography-root': {
                color: theme.palette.primary.main,
                fontSize: '18px',
                fontWeight: 700,
            },
        },
        schoolName: {
            color: theme.palette.grey.header,
            fontSize: '16px',
        },
    };
});

export default useStyles;
